import { Grid, Typography } from '@mui/material';
import colors from 'styles/colors';
import useCompetitionStore from 'store/competitionStore';
import getCompetitionTiming from 'utils/competitionTiming';
import Box from '@mui/material/Box';
import Problem1 from 'assets/svgIcons/Problem_1.svg';
import Problem2 from 'assets/svgIcons/Problem_2.svg';
import Problem3 from 'assets/svgIcons/Problem_3.svg';
import Problem4 from 'assets/svgIcons/Problem_4.svg';
import Problem5 from 'assets/svgIcons/Problem_5.svg';
import Problem6 from 'assets/svgIcons/Problem_6.svg';
import SubmissionProblemInput from './SubmissionProblemInput';
import SubmissionList from './SubmissionList';

const ProblemCard = ({
  config, problemName, submissions, formik, handleBlurValidate, handleFieldSubmit, descriptionConfig,
}) => {
  const competition = useCompetitionStore((state) => state.competition.details);
  const { hasEnded } = getCompetitionTiming(competition);

  const {
    points, validationPattern, validationMessage, order, ...rest
  } = config;

  const getProblemSvg = (problemOrder) => {
    switch (problemOrder) {
      case 1:
        return { problemSvg: Problem1, scale: 1 };
      case 2:
        return { problemSvg: Problem2, scale: 1 };
      case 3:
        return { problemSvg: Problem3, scale: 0.85 };
      case 4:
        return { problemSvg: Problem4, scale: 1.1 };
      case 5:
        return { problemSvg: Problem5, scale: 1 };
      case 6:
        return { problemSvg: Problem6, scale: 1 };
      default:
        return null;
    }
  };

  const ProblemSvg = getProblemSvg(order)?.problemSvg;
  const ProblemSvgScale = getProblemSvg(order)?.scale;
  return (
    <Grid
      container
      justifyContent="center"
      sx={{
        border: `1px solid ${colors.border.border_5p}`,
        background: 'rgba(255, 255, 255, 0.04)',
        borderRadius: '8px',
        marginBottom: '24px',
        padding: '24px',
        minHeight: '255px',
        '&:last-child': {
          marginBottom: 0,
        },
      }}
    >
      <Box sx={{
        display: 'flex', width: '100%', flexWrap: 'wrap', justifyContent: 'space-between',
      }}
      >
        <Box sx={{ minHeight: '48px', marginBottom: '16px', flex: '0 0 350px' }}>
          <Typography
            variant="p"
            gutterBottom
            sx={{
              color: colors.text.secondary,
              fontSize: '16px',
              lineHeight: '20px',
              fontWeight: '600',
            }}
          >
            {`Problem ${order}:`}
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ color: colors.text.primary }}
          >
            {problemName}
          </Typography>
          {ProblemSvg && (
            <Box sx={{
              marginTop: '24px',
              fontWeight: '600',
              svg: {
                scale: ProblemSvgScale,
              },
            }}
            >
              <ProblemSvg />
            </Box>
          )}
        </Box>
        {!hasEnded ? (
          <Box sx={{
            flex: '1 1 auto', minWidth: '350px', maxWidth: '500px',
          }}
          >
            <SubmissionProblemInput
              config={rest}
              descriptionConfig={descriptionConfig}
              formik={formik}
              onBlur={handleBlurValidate}
              handleSubmit={handleFieldSubmit}
              maxSubmissions={competition.maxSubmissions}
              submittedCount={submissions.length || 0}
            />
          </Box>
        ) : null}
      </Box>

      <Grid item xs={config.grid}>
        <SubmissionList submissions={submissions} grid={config.grid} points={config.points} />
      </Grid>
    </Grid>
  );
};

export default ProblemCard;
